import type { FC } from "react";
import clsx from "clsx";

import styles from "./divider.module.scss";

interface DividerProps {
  marginTop?: number | string;
  marginBottom?: number | string;
  color?: "neutral-100" | "neutral-300";
}

const Divider: FC<DividerProps> = ({
  marginTop = 16,
  marginBottom = 16,
  color = "neutral-300",
}) => {
  return (
    <div
      className={clsx(styles.divider, color && styles[`divider--${color}`])}
      style={{
        marginTop: typeof marginTop === "number" ? `${marginTop}px` : marginTop,
        marginBottom:
          typeof marginBottom === "number" ? `${marginBottom}px` : marginBottom,
      }}
    />
  );
};

export default Divider;
